import React from 'react';
import styled from 'styled-components';
import Button from '../components/core/Button';

const ErrorModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 26rem;
    .main {
        margin-bottom: 4rem;
        text-align: left;
    }
    #heading {
        font-size: 1.8rem;
    }
    #subheading {
        font-size: 1.6rem;
        color: var(--color-battleship_grey);
    }
    button {
        margin-top: auto;
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
`;
const ErrorModal = ({
    heading = 'Technical Error',
    subheading = "We're facing some technical error.",
    buttonText = 'Close',
    onClick,
    onClose
}) => {
    return (
        <ErrorModalWrapper>
            <div className="main">
                <p id="heading">{heading}</p>
                <p id="subheading">{subheading}</p>
            </div>
            <Button onClick={onClick || onClose}>{buttonText}</Button>
        </ErrorModalWrapper>
    );
};
export default ErrorModal;
